import React from "react";
import ErrorMessage from "./ErrorMessage";
import { Box } from "../ui/chakra";

const RegistrationWarning = () => {
  return (
    <ErrorMessage>
      <Box fontSize="sm" color="textBase">
        <Box
          as="span"
          fontWeight="bold"
          color="caution"
        >
          本人確認のために建築士免許証をご提示いただきます。
        </Box>
        <br />
        ご提示いただいた建築士免許証は本人確認のみに利用し、公開されることはありません。
      </Box>
    </ErrorMessage>
  );
};

export default RegistrationWarning;
